(function(global) {
    'use strict';

    var lib = global.lib || (global.lib = {}),
        cjs = global.createjs || (global.createjs = {}),
        images = global.images || (global.images = {}),
        preloader,
        canvas, stage, exportRoot;

    function init() {
        preloader = document.getElementById("preloader");
        canvas = document.getElementById("canvas");
        //canvas.width = global.innerWidth/global.innerHeight * canvas.height;
        
        var loader = new cjs.LoadQueue(false);
        loader.installPlugin(cjs.Sound);
        loader.addEventListener("progress", handleProgress);
        loader.addEventListener("fileload", handleFileLoad);
        loader.addEventListener("complete", handleComplete);
        loader.loadManifest(lib.properties.manifest);
    }
    
    function handleProgress(evt) {
        preloader.innerHTML = (evt.loaded * 100).toFixed(2)+"%";
    }

    function handleFileLoad(evt) {
        if (evt.item.type == "image") { 
            images[evt.item.id] = evt.result;
        }
    }

    function handleComplete(evt) {
        preloader.style.display = "none";
        
        exportRoot = new lib.mms_Canvas();
        //exportRoot.x = canvas.width / 2;

        stage = new cjs.Stage(canvas);
        cjs.Touch.enable(stage);
        stage.addChild(exportRoot);
        stage.update();

        TweenLite.ticker.addEventListener("tick", stage.update, stage);
        cjs.Ticker.timingMode = cjs.Ticker.RAF;
        //cjs.Ticker.setFPS(lib.properties.fps);
        //cjs.Ticker.addEventListener("tick", stage);
    }
    
    global.onload = init;
  
})(this);